import React from 'react'
import styled, { keyframes } from 'styled-components'
import { GLOBAL_COLORS } from 'theme'

const fade = keyframes`
   0% {
      opacity: .25;
      transform: scale(0);
    }
    100% {
      opacity: 0;
      transform: scale(1);
    }
`

const Circles = styled.div`
  height: 42px;
  position: relative;
  width: 42px;
  margin-top: 10px;
  & > div {
    animation: ${fade} 0.9s infinite ease-out;
    background-color: ${GLOBAL_COLORS.ultramarine};
    border-radius: 50%;
    height: 100%;
    opacity: 0;
    position: absolute;
    width: 100%;
  }
`

const FirstCircle = styled.div`
  animation-delay: 0.3s;
`

const SecondCircle = styled.div`
  animation-delay: 0.6s;
`

const ThirdCircle = styled.div`
  animation-delay: 0.9s;
`

export const CoinLoader = (): JSX.Element => {
  return (
    <Circles>
      <FirstCircle />
      <SecondCircle />
      <ThirdCircle />
    </Circles>
  )
}
